// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-flags .header h2 {
    text-align: center;
}
.feature-flags .feature-rows-header {
    font-weight: bold;
    border-bottom: thin solid var(--main-border-color);
}
`, "",{"version":3,"sources":["webpack://./client/components/admin/features/FeatureFlags.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kDAAkD;AACtD","sourcesContent":[".feature-flags .header h2 {\n    text-align: center;\n}\n.feature-flags .feature-rows-header {\n    font-weight: bold;\n    border-bottom: thin solid var(--main-border-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
